import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModelAudit } from 'src/app/model/audit';
import { ModelTableHeader } from 'src/app/model/table-header';
import { ModelTableHoverDetail, ModelTableHoverDetailItem } from '../data-table/basic-table/models';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";

@Component({
  selector: 'app-audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.scss']
})
export class AuditLogComponent implements OnInit {
  _mColumns: any;
  _data: any = {};
  _commondata: any = {};
  str: any = {};
  changedData: any;
  modelAudits: ModelAudit[] = [];
  templateflag: any = false;
  oldValue: any;
  newValue: any;
  id: any;
  name: any;
  data1: any;
  list: any;
  allExpandState: any;
  _matColumns: ModelTableHeader[];

  constructor(
    public dialogRef: MatDialogRef<AuditLogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: any,
    // private bottomSheetRef: MatBottomSheetRef<AuditLogComponent>,
    // @Inject(MAT_BOTTOM_SHEET_DATA) public data?: any
  ) {
    if (data.header) {
      if (data.header == 'present') {
        this._mColumns = data.header;
        this._commondata = data.data;
      } else {
        this._matColumns = data.header;
        this._data = this._processTableData(data.data);
        this._data.view = data.view;
      }
    } else {
      this._data = data.data;
    }
  }

  ngOnInit(): void {
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  closeSheet(): void {
    // this.bottomSheetRef.dismiss();
  }

  open(modifiedData) {
    this.changedData = modifiedData.object2;
    this.modelAudits = [];
    Object.keys(this.changedData).forEach(key => {
      let newobject = new ModelAudit();
      newobject.fieldNames = key;
      this.name = null;
      this.id = null;
      if (typeof (this.changedData[key].right) !== 'object' || typeof (this.changedData[key].left) !== 'object') {
        newobject.oldValues = this.changedData[key].left;
        newobject.newValues = this.changedData[key].right;
      }
      else if (typeof (this.changedData[key].right) === 'object' || typeof (this.changedData[key].left) === 'object') {
        if (this.changedData[key].left != null) {
          newobject.oldValues = this.getOldValues(this.changedData[key].left);
        }
        newobject.newValues = this.getNewValues(this.changedData[key].right);
      }
      if (newobject.newValues !== newobject.oldValues) {

        this.modelAudits.push(newobject);
      }
    })
    this.templateflag = true;
  }

  getOldValues(data) {
    this.str = JSON.stringify(data);
    this.data1 = JSON.parse(this.str);
    this.list = " ";
    if (Array.isArray(this.data1)) {
      this.data1.forEach(element => {
        if (typeof (element) !== 'object') {
          this.list = this.data1.toString();
        } else {
          Object.keys(element).forEach(s => {
            this.data1 = element
            if (s.toString().toLowerCase().endsWith('type')) {
              this.list = this.list + " " + element[s]
            }
            if (s.toString().toLowerCase().endsWith('name') && !s.toString().toLowerCase().endsWith('rname'))
              this.list = this.list + " " + element[s]
          });
        }
      })
      return this.list;
    } else {
      if (this.data1 !== null) {
        this.oldValue = "";
        Object.keys(this.data1).forEach(s => {
          if (!s.toString().toLowerCase().endsWith('personname') && (s.toString().toLowerCase().endsWith('name'))) {
            this.name = this.data1[s]
          }
          if (s.toString().toLowerCase().endsWith('id')) {
            this.id = this.data1[s];
          }
          if (!this.name && !this.id) {
            this.oldValue = null
          } else if (this.name && this.id) {
            this.oldValue = "id: " + this.id + " name: " + this.name;
          } else if (this.id) {
            this.oldValue = "id: " + this.id;
          }
        })
      }
      return this.oldValue;
    }
  }

  getNewValues(data) {
    this.str = JSON.stringify(data);
    this.data1 = JSON.parse(this.str);
    this.list = " ";
    if (Array.isArray(this.data1)) {
      this.data1.forEach(element => {
        if (typeof (element) != 'object') {
          this.list = this.data1.toString();
        } else {
          Object.keys(element).forEach(s => {
            this.data1 = element
            if (s.toString().toLowerCase().endsWith('type')) {
              this.list = this.list + " " + element[s]
            }
            if (s.toString().toLowerCase().endsWith('name') && !s.toString().toLowerCase().endsWith('rname'))
              this.list = this.list + " " + element[s]
          });
        }
      })
      return this.list;
    } else {
      if (this.data1 !== null) {
        this.newValue = "";
        Object.keys(this.data1).forEach(s => {
          if (!s.toString().toLowerCase().endsWith('personname') && (s.toString().toLowerCase().endsWith('name'))) {
            this.name = this.data1[s]
          }
          if (s.toString().toLowerCase().endsWith('id')) {
            this.id = this.data1[s];
          }
          if (!this.name && !this.id) {
            this.newValue = null
          } else if (this.name && this.id) {
            this.newValue = "id: " + this.id + " name: " + this.name;
          } else if (this.id) {
            this.newValue = "id: " + this.id;
          }
        })
      }
      return this.newValue;
    }
  }

  _processTableData(pDdata: any[]): any[] {
    let data: any[] = [];
    if (pDdata) {
      pDdata.forEach(pElement => {
        this._matColumns.forEach((column: ModelTableHeader) => {
          if (column.key.includes("menus")) {
            let menus = [];
            if (pElement.menuList) {
              pElement.menuList.forEach(menu => {
                menus.push(new ModelTableHoverDetailItem('', menu.menuName, column.key));
              });
            }
            pElement.menus = new ModelTableHoverDetail(menus);
          } else if (column.key.includes("roles")) {
            let roles = [];
            if (pElement.roleList) {
              pElement.roleList.forEach(role => {
                roles.push(new ModelTableHoverDetailItem('', role.roleName, column.key));
              });
            }
            pElement.roles = new ModelTableHoverDetail(roles);
          } else if (column.key.includes("projects")) {
            let projects = [];
            if (pElement.projectList) {
              pElement.projectList.forEach(project => {
                projects.push(new ModelTableHoverDetailItem('', project.projectName, column.key));
              });
            }
            pElement.projects = new ModelTableHoverDetail(projects);
          } else if (column.key.includes("sites")) {
            let sites = [];
            if (pElement.siteList) {
              pElement.siteList.forEach(site => {
                sites.push(new ModelTableHoverDetailItem('', site.siteName, column.key));
              });
            }
            pElement.sites = new ModelTableHoverDetail(sites);
          } else if (column.key.includes("alertTypes")) {
            let alertTypes = [];
            if (pElement.alertList) {
              pElement.alertList.forEach(alertType => {
                alertTypes.push(new ModelTableHoverDetailItem('', alertType.notificationType, column.key));
              });
            }
            pElement.alertTypes = new ModelTableHoverDetail(alertTypes);
          } else if (column.key.includes("recipientRoles")) {
            let recipientRoles = [];
            if (pElement.recipientList) {
              pElement.recipientList.forEach(recipientRole => {
                recipientRoles.push(new ModelTableHoverDetailItem('', recipientRole.recipientRole, column.key));
              });
            }
            pElement.recipientRoles = new ModelTableHoverDetail(recipientRoles);
          } else if (column.key.includes("ccRoles")) {
            let ccRoles = [];
            if (pElement.ccList) {
              pElement.ccList.forEach(ccRole => {
                ccRoles.push(new ModelTableHoverDetailItem('', ccRole.ccRole, column.key));
              });
            }
            pElement.ccRoles = new ModelTableHoverDetail(ccRoles);
          } else if (column.key.includes("bcc_Roles")) {
            let bcc_Roles = [];
            if (pElement.bccList) {
              pElement.bccList.forEach(bccRole => {
                bcc_Roles.push(new ModelTableHoverDetailItem('', bccRole.bccRole, column.key));
              });
            }
            pElement.bcc_Roles = new ModelTableHoverDetail(bcc_Roles);
          } else if (column.key.includes("requesterRoles")) {
            let requesterRoles = [];
            if (pElement.requesterList) {
              pElement.requesterList.forEach(requesterRole => {
                requesterRoles.push(new ModelTableHoverDetailItem('', requesterRole.requesterRole, column.key));
              });
            }
            pElement.requesterRoles = new ModelTableHoverDetail(requesterRoles);
          } else if (column.key.includes("approverRoles")) {
            let approverRoles = [];
            if (pElement.approverList) {
              pElement.approverList.forEach(approverRole => {
                approverRoles.push(new ModelTableHoverDetailItem('', approverRole.approverRole, column.key));
              });
            }
            pElement.approverRoles = new ModelTableHoverDetail(approverRoles);
          } else if (column.key.includes("drivers")) {
            let drivers = [];
            if (pElement.driverList) {
              pElement.driverList.forEach(driverName => {
                drivers.push(new ModelTableHoverDetailItem('', driverName.driverName, column.key));
              });
            }
            pElement.drivers = new ModelTableHoverDetail(drivers);
          } else if (column.key.includes("userCategories")) {
            let userCategories = [];
            if (pElement.userCategoryList) {
              pElement.userCategoryList.forEach(userCategoryName => {
                userCategories.push(new ModelTableHoverDetailItem('', userCategoryName.userCategoryName, column.key));
              });
            }
            pElement.userCategories = new ModelTableHoverDetail(userCategories);
          } else {
            pElement[column.key] = pElement[column.key];
          }
        });
        data.push(pElement);
      });
    }
    return data;
  }

}
